import React from 'react';
import ReportFrame from '../ReportFrame';

export default class TaxReport extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='TaxReport'
          reportParams={reportParams}
          id='taxreport'
          name='taxreport'
          title='Tax Report'
        />
      </div>
    );
  }
}
